export default { // production db keys
  MFG: "4M7fkx6ma4i190WZFEgC",
  BRAND: "xBinF6txfjsYvXBAiL6K",
  CONDITION: "KuBsRzCF5pWeuzJCmUR4",
  BATTERIES: "z5pzvKlCQuNGdhFRw3KA",
  REFLASHING: "hNI5heWokhrlIk2x5K9p",
  KEY_CATEGORY: "gM93r0irfZvOt5o4q9sw",
  BUTTON: "6q5lbwjxykN6xmRA3kLn",
  TOTAL_TOKENS: "LKcEc1pmNgEuiCUOcdn2",
  PIN_CODE: "iDe8q4wLhHZqjQVm0r0X",
  REUSABLE: "XRnab42JTPeCZ9RvU3WV",
  CLONEABLE: "Ig0LXKjfXB2L2Vjn4sGN",
  PROGRAM_REMOTE: "mzuZ6EMPSGlFAhw21Iw9",
  ADD_KEY: "1cJCKoo9hACUHYAm1LBG",
  LISH: "lNQxFrDfyQ2MmuFUGFgF",
  FREQUENCY: "Olszv4bHZva1KQRJhQWz",
  ADDITIONAL_HARDWARE: "mk9JzgnbF6lrMu2PFkfC",
};
